/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function CreateSiteSectionRequestSiteSectionFromJSON(json) {
    return CreateSiteSectionRequestSiteSectionFromJSONTyped(json, false);
}
export function CreateSiteSectionRequestSiteSectionFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        name: !exists(json, 'name') ? undefined : json['name'],
        sort: !exists(json, 'sort') ? undefined : json['sort']
    };
}
export function CreateSiteSectionRequestSiteSectionToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        name: value.name,
        sort: value.sort
    };
}
